/* eslint-disable */
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Typography } from "@material-ui/core";
import { useStyles } from "./BulkExportToolbar.styles";
import { BackButton } from "../../../basf-ui";
import { EmailInput } from "./EmailInput";
import { messages } from "./BulkExportToolbar.messages";
import { ExportTriggerButton } from "../ExportTriggerButton";

export const BulkExportToolbar: React.FC = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <BackButton />
      <Typography className={classes.titlePage}>
        <FormattedMessage {...messages.titlePage} />
      </Typography>
      <div className={classes.actions}>
        <EmailInput />
        <ExportTriggerButton />
      </div>
    </div>
  );
};
